export default {
  methods: {
    stationCategoryChange() {
      // var currentSideMenuSetting = this.$store.getters['stations/CurrentSideMenuSetting']
      // currentSideMenuSetting.GroupType.forEach(element => {
      //   if (element == 'station_category') {
      //     var options = {
      //       RoleName: this.$store.getters['authenticate/currentUserGroup'].name,
      //       GroupType: currentSideMenuSetting.GroupType,
      //       OrderType: currentSideMenuSetting.OrderType,
      //     }
      //     // FIX ME
      //     // this.setSideMenuGrouper(options)
      //   }
      // })
    },
    continuousStationCategoryChange() {
      // var currentContinuousStationSideMenuSetting = this.$store.getters['stations/CurrentContinuousStationSideMenuSetting']
      // var options = {
      //   RoleName: this.$store.getters['authenticate/currentUserGroup'].name,
      //   GroupType: currentContinuousStationSideMenuSetting.GroupType,
      //   OrderType: currentContinuousStationSideMenuSetting.OrderType,
      // }
      // // FIX ME
      // //this.setContinuousSideMenuGrouper(options)
    },
  },
}